import { Box, Typography } from '@mui/material';
import { ReactComponent as AddToListIcon } from 'assets/add-to-list.svg';
import PlusIcon from 'assets/add-white.svg';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import { useAppDispatch } from 'store/hooks';
import { setAdminSearchModal } from 'store/slices/businessesSlice';
import zeplinColor from 'theme/Color';
import { styles } from './styles';
import style from './styles.module.css';

const NoResults = () => {
  const dispatch = useAppDispatch();

  return (
    <Box sx={{ ...styles.container }}>
      <AddToListIcon />
      <Box sx={{ ...styles.textContainer }}>
        <Typography variant='responsiveHeading3'>No Bussiness Added Yet</Typography>
        <Typography variant='responsiveBody3' style={{ color: zeplinColor.Neutral8 }}>
          Create a project to organize tasks, track progress, and move your work forward.
        </Typography>
      </Box>
      <CustomButton
        icon={<img src={PlusIcon} className={style.icon} alt='white arrow' />}
        iconPosition='start'
        variant={'contained'}
        text={<Typography variant='responsiveButtonMedium'>New Business</Typography>}
        style={{ ...styles.button }}
        onClick={() => dispatch(setAdminSearchModal(true))}
        disabled={false}
      />
    </Box>
  );
};

export default NoResults;
